<p-dialog [(visible)]="dialogFormVisible"
          [header]="'page.help.title'|translate"
          [modal]="true" styleClass="p-fluid"
          [closeOnEscape]="true"
          appendTo="body" position="top"
          (onHide)="dialogFormVisibleChange.emit(false)"
          (onShow)="dialogFormVisibleChange.emit(true)"
          [resizable]="false">
  <ng-template pTemplate="content">
    <div>
      <!--    <ul>-->
      <!--      <li>technologues</li>-->
      <!--      <li>chercheurs</li>-->
      <!--      <li>bâtisseurs</li>-->
      <!--    </ul>-->
      <h4>{{'page.help.shortcuts.title'|translate}}</h4>
      <p>{{'page.help.shortcuts.table.filterCell.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.filterCell.value'|translate}}</span></p>
      <br/>
      <p>{{'page.help.shortcuts.table.clearFilter.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.clearFilter.value'|translate}}</span></p>
      <p>{{'page.help.shortcuts.table.clearSort.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.clearSort.value'|translate}}</span></p>
      <br/>
      <p>{{'page.help.shortcuts.table.selectAllRows.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.selectAllRows.value'|translate}}</span></p>
      <p>{{'page.help.shortcuts.table.selectTableRows.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.selectTableRows.value'|translate}}</span></p>
      <br/>
      <p>{{'page.help.shortcuts.table.submitForm.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.submitForm.value'|translate}}</span></p>
      <br/>
      <p *ngIf="isClearingTrader()">{{'page.help.shortcuts.table.editSelection.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.editSelection.value'|translate}}</span></p>
      <p *ngIf="isClearingTrader()">{{'page.help.shortcuts.table.allocateSelection.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.table.allocateSelection.value'|translate}}</span></p>
      <br/>
      <p>{{'page.help.shortcuts.app.clearCookies.title'|translate}}:
        <span class="short-cut-val">{{'page.help.shortcuts.app.clearCookies.value'|translate}}</span></p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="closeDialog()"
            [label]="'common.dialog.close' | translate"
            class="p-button-warning p-button-sm"></button>
  </ng-template>
</p-dialog>
